import { Button } from '../../../cdl/Button/Button';
import { Box } from '../../../common/ui/Box';
import { ContractSelection } from '../../create-enquiry/components/ContractSelection';
import { SupplierSelectionRowData } from '../../create-enquiry/components/SupplierSelection.types';
import { SupplierSelectionRow } from '../../create-enquiry/components/SupplierSelectionRow';

interface SupplierSelectionListProps {
    rows: SupplierSelectionRowData[];
    onToggleAll?: () => void;
    toggleAllLabel?: string;
}

export const SupplierSelectionList = ({ rows, onToggleAll, toggleAllLabel }: SupplierSelectionListProps) => {
    const hasSelectableSupplierRows = rows.some((row) => !row.disabled);

    return (
        <Box display="flex" flexDirection="column" gap={8}>
            <Box display="flex" flexDirection="column" gap={8}>
                {rows.map((row) => {
                    return (
                        <Box key={row.id} display="flex" flexDirection="column">
                            <SupplierSelectionRow row={row} />
                            <ContractSelection row={row} />
                        </Box>
                    );
                })}
            </Box>

            {onToggleAll && toggleAllLabel && hasSelectableSupplierRows ? (
                <Box display="flex" justifyContent="flex-end">
                    <Button type="button" emphasis="low" size="small" onClick={onToggleAll}>
                        {toggleAllLabel}
                    </Button>
                </Box>
            ) : null}
        </Box>
    );
};
